import moment from 'moment'

export const NomorSuratMonthYear = () => {
    moment.locale('id');
    const now = moment();
    const month = now.month() + 1; // Because moment.js months are 0-based
    const year = now.year();

    // Function to convert month to Roman numerals
    function toRoman(num) {
        const roman = ['I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X', 'XI', 'XII'];
        return roman[num - 1];
    }

    return `${toRoman(month)}/${year}`;
}

export const SuratDate = () => {
    moment.locale('id');
    return moment().format('dddd, DD/MMMM/YYYY');
}

export const SuratDateTime = () => {
    moment.locale('id');
    return moment().format('HH:mm:ss');
}

export const SuratDateExaminedFormat = () => {
    moment.locale('id');
    return moment().format('dddd, DD MMMM YYYY');
}

export const SuratPersetujuanDate = (ValueDate) => {
    moment.locale('id');
    return moment(ValueDate, SuratPersetujuanFormat()).format(SuratPersetujuanDateFormat());
}

export const SuratPersetujuanDateFormat = () => 'DD/MMMM/YYYY'

export const SuratPersetujuanFormat = () => 'YYYY-MM-DD'

export const SuratDatePickerFormat = () => 'DD-MM-YYYY'

export const SuratDatePicker = () => {
    moment.locale('id')
    return moment().format(SuratDatePickerFormat())
}

export const SuratDatePickerDisabledPreviousDate = (CurrentDate, TargetDate) => {
    moment.locale('id')

    const CurrentDateMoment = moment(CurrentDate, SuratDatePickerFormat());
    const TargetDateMoment = moment(TargetDate, SuratDatePickerFormat());

    return TargetDateMoment.isBefore(CurrentDateMoment);
}

export const SuratDatePickerDisabledNextDate = (CurrentDate, TargetDate) => {
    moment.locale('id')

    const CurrentDateMoment = moment(CurrentDate, SuratDatePickerFormat());
    const TargetDateMoment = moment(TargetDate, SuratDatePickerFormat());

    return TargetDateMoment.isAfter(CurrentDateMoment);
}